import { LAYOUTS, POSITION, } from '@voltmoney/types';
import { WIDGET } from '@voltmoney/schema';
import { ROUTE } from '../../routes';
import { PartnerBodyWeb } from './partnerBodyWeb';
import { DisableSubmit, getPlatformCode, getPlatformPassword, GoToFaq, GoToHome, GoToPhone, GoToPrivacy, GoToWhatsapp, ToggleCTA, verifyPlatformDetails, WhatsappToggle, } from './actions';
import { ACTION } from './types';
import { QUERY_PARAMS } from '../../configs/constants';
import { isMobile } from '../../configs/utils';
import { PartnerBodyMob } from './PartnerBodyMob';
import { getAppHeader } from "../../configs/config";
import { PartnerHeader } from "../dashboard/partnerHeader";
import { platformApi, StoreKey } from "../../configs/api";
export const template = async (path, partnerName, partnerPhoneNumber, _isMobile, refCode, referredPartner, showEmailScreen, metaData) => ({
    layout: {
        id: ROUTE.PLATFORM_SIGN_UP,
        type: LAYOUTS.LIST,
        style: {
            isPartnerPlatform: true,
        },
        widgets: [
            {
                id: 'partnerHeader',
                type: WIDGET.STACK,
                position: POSITION.ABSOLUTE_TOP,
            },
            _isMobile
                ? { id: 'partnerBodyMob', type: WIDGET.STACK }
                : { id: 'partnerBodyWeb', type: WIDGET.STACK },
        ],
    },
    datastore: {
        ...(await PartnerHeader(ROUTE.PLATFORM_SIGN_UP, true)),
        ...(_isMobile
            ? await PartnerBodyMob(path, partnerName, partnerPhoneNumber, refCode, referredPartner, metaData, showEmailScreen)
            : await PartnerBodyWeb(path, partnerName, partnerPhoneNumber, refCode, referredPartner, metaData, showEmailScreen)),
    },
});
export const platformSignupMF = {
    onLoad: async ({ setDatastore, network, metaData, navigate, asyncStorage, openNewTab, instrumentTrack }, { route }) => {
        const accessToken = await asyncStorage.get(StoreKey.accessToken);
        if (accessToken) {
            const header = await getAppHeader();
            header['X-AppPlatform'] = await asyncStorage.get(StoreKey.APP_PLATFORM);
            const validateToken = await network.get(`${platformApi.validateToken}`, { headers: header });
            if (validateToken.status === 200) {
                await navigate(ROUTE.PLATFORM_DASHBOARD);
            }
        }
        const path = route?.path;
        const params = route?.params;
        const refCode = params?.[QUERY_PARAMS.REF];
        const referredPartner = params?.[QUERY_PARAMS.REFERRED_PARTNER];
        const partnerName = '';
        const partnerPhoneNumber = '';
        const _isMobile = isMobile();
        const partnerEmail = undefined;
        const showEmailScreen = false;
        return Promise.resolve(template(path, partnerName, partnerPhoneNumber, _isMobile, refCode, referredPartner, showEmailScreen, metaData));
    },
    actions: {
        [ACTION.PLATFORM_CODE]: getPlatformCode,
        [ACTION.PLATFORM_PASSWORD]: getPlatformPassword,
        [ACTION.ENABLE_CONTINUE_PHONE_NUMBER]: ToggleCTA,
        [ACTION.DISABLE_CONTINUE_PHONE_NUMBER]: ToggleCTA,
        [ACTION.PRIVACY]: GoToPrivacy,
        [ACTION.WHATSAPP_CHECK]: WhatsappToggle,
        [ACTION.WHATSAPP_UNCHECK]: WhatsappToggle,
        [ACTION.DISABLE_SUBMIT]: DisableSubmit,
        [ACTION.GO_TO_HOME]: GoToHome,
        [ACTION.GO_TO_FAQ]: GoToFaq,
        [ACTION.GO_TO_CALL]: GoToPhone,
        [ACTION.GO_TO_WHATSAPP]: GoToWhatsapp,
        [ACTION.VERIFY_PLATFORM_DATA]: verifyPlatformDetails,
    },
};
